import React, {useState} from "react";

const RefreshContext = React.createContext({refreshID: 0, refresh: () => {}});

// Provides [refreshID] to its children. When refreshID changes, interested children can rerender themselves.
// Child component can signal siblings to update their state by calling [refresh].
// Example use case:
// <RefreshProvider><Dashboard><Notification/><Calendar/></Dashboard></RefreshProvider>
// If student closes a TO-DO in Notification component, then the Calendar component should also update to clear the To-Do.
// So once clear To-Do request is submitted, Notification uses [refresh] to update the [refreshID]
// and the Calendar looks at [refreshID] to reload its data.
export function RefreshProvider({children}) {
    const [refreshID, setRefreshID] = useState(0);
    function refresh() {
        setRefreshID(refreshID + 1);
    }
    return (
        <RefreshContext.Provider value={{refreshID, refresh}}>
            {children}
        </RefreshContext.Provider>
    );
}

export function useRefreshContext() {
    return React.useContext(RefreshContext);
}
